import { render, staticRenderFns } from "./ShopStatisticCard.vue?vue&type=template&id=6bd7dab2&scoped=true"
import script from "./ShopStatisticCard.vue?vue&type=script&lang=js"
export * from "./ShopStatisticCard.vue?vue&type=script&lang=js"
import style0 from "./ShopStatisticCard.vue?vue&type=style&index=0&id=6bd7dab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd7dab2",
  null
  
)

export default component.exports